// extracted by mini-css-extract-plugin
export default {"button":"Button_button__ufG7+","danger":"Button_danger__qHXbV","empty":"Button_empty__Ir7pi"};